// Modal de checkout com formulário de lead
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { LeadForm } from './LeadForm';

interface CheckoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CheckoutModal({ isOpen, onClose }: CheckoutModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-primary-900/80 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="bg-white rounded-2xl p-8 max-w-2xl w-full shadow-2xl max-h-[90vh] overflow-y-auto border border-primary-200"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-2xl font-bold text-primary-800">
                  Meu Primeiro Jardim de Fé
                </h2>
                <p className="text-gray-600 mt-1">
                  Complete seus dados para continuar
                </p>
              </div>
              <button
                onClick={onClose}
                className="p-2 rounded-full hover:bg-primary-50 transition-colors"
                aria-label="Fechar modal"
              >
                <X className="h-6 w-6 text-primary-600" />
              </button>
            </div>

            {/* Formulário de Lead */}
            <LeadForm 
              className="shadow-none border-0 p-0"
            />

            {/* Footer */}
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500">
                Seus dados serão preenchidos automaticamente no checkout
              </p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
